import Card from '@/components/ui/Card';
import ConfigForm from './ConfigForm';

export default function ConfigCard() {
  return (
    <Card title="Configurations">
      <ConfigForm />
    </Card>
  );
}
